import axios from "axios";
import { MMSettingsAdminConnection } from "./types";

const API_URL = "https://lukkypro.ru/api/v1/";

export const getListConnectionPair = async () => {
    const { data } = await axios.get<MMSettingsAdminConnection[]>(
        `${API_URL}connections/list`,
        {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        }
    );
    return data;
};

export const toggleConnectionState = async (id: string) => {
    await axios.post(
        `${API_URL}connections/${id}/switch_state`,
        {},
        {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        }
    );
};

export const deleteConnection = async (id: string) => {
    await axios.delete(`${API_URL}connections/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
};
